import React from 'react';
// import { colors } from '../utils/colors';

const style = {
   height: '30px',
   position: 'absolute',
   top: '2em',
   width: '200px',
   background: 'transparent'
}

const ManchetaDesktop = (props) => (
   <a href="http://www.diariodecadiz.es/" target="_blank" rel="noopener noreferrer" >
      <img style={{...style, right: `${props.width / 2 - 100}px`, opacity: '.8'}} src='./img/manchetainv/logo.svg' alt="Diario de Cádiz"/>
   </a>
);

export default ManchetaDesktop;



// WEBPACK FOOTER //
// ./src/components/ManchetaDesktop.js